export default __webpack_public_path__ + "static/media/ondersteunende-relaties.e3a22bac.svg";